import { render, staticRenderFns } from "./RecentFeedbackWidget.vue?vue&type=template&id=64a95ee2&scoped=true"
import script from "./RecentFeedbackWidget.vue?vue&type=script&lang=js"
export * from "./RecentFeedbackWidget.vue?vue&type=script&lang=js"
import style0 from "./RecentFeedbackWidget.vue?vue&type=style&index=0&id=64a95ee2&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64a95ee2",
  null
  
)

export default component.exports